export default {
  namespaced: true,
  state: {
    subscribers: {}
  },
  mutations: {
    subscribe(state, subscriber) {
      state.subscribers[subscriber.key] = subscriber.event;
    },
    unsubscribe(state, key) {
      if(state.subscribers[key]) {
        delete state.subscribers[key];
      }
    }
  },
  actions: {
    subscribe({commit}, subscriber) {
      commit('subscribe', subscriber);
    },
    notify({state}, to) {
      for (let subscriberKey of Object.keys(state.subscribers)) {
        const subscriber = state.subscribers[subscriberKey];
        if (subscriber(to) === false)
          return Promise.resolve(false)
      }
      return Promise.resolve(true);
    },
    unsubscribe({commit}, key) {
      commit('unsubscribe', key)
    }
  }
}
